import { controls,grouped } from "../controls";
const widget_labels = {
label: "Widget Values",
pageLabel: "Widget Values",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Display Field"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "display_field",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "filter", label: "Url Field"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "url_field",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "filter", label: "Truncate After"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "truncate_after",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Width"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "width",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "filter", label: "Font"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "font",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "filter", label: "Font Size"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "font_size",width:"col-sm-4",maxlength:100}),
]
,form:[
...controls.displayText({ tab: "general", label: "Display Field",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "display_field",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Display Condition",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "display_condition",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "general", label: "Url Field",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "url_field",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Truncate After",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "truncate_after",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Width",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "width",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Font",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "font",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Font Size",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "font_size",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Background Color",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "background_color",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Background Color Condition",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "background_color_condition",width:"col-sm-4",maxlength:200}),
...controls.checkBox({ tab: "general", label: "Is Clickable",default:false, name: "is_clickable" }),
...controls.checkBox({ tab: "general", label: "Is Open In New",default:false, name: "is_open_in_new" }),
]
,history:{
perPage: 10,
reportHeader: "Widget Values",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Display Field",accessor: "display_field",},
{Header: "Display Condition",accessor: "display_condition",},
{Header: "Url Field",accessor: "url_field",},
{Header: "Truncate After",accessor: "truncate_after",},
{Header: "Width",accessor: "width",},
{Header: "Font",accessor: "font",},
{Header: "Font Size",accessor: "font_size",},
{Header: "Background Color",accessor: "background_color",},
{Header: "Background Color Condition",accessor: "background_color_condition",},
{Header: "Is Clickable",accessor: "is_clickable",type:'tick'},
{Header: "Is Open In New",accessor: "is_open_in_new",type:'tick'},
]}};
export default widget_labels;